import GmailDteComprasTable from "views/admin/tables/components/GmailDteComprasTable";
import ComprasAcceptanceSettings from "./ComprasAcceptanceSettings";

export default function DteComprasPage() {
  return (
    <div className="mt-3">
      <ComprasAcceptanceSettings />
      <GmailDteComprasTable />
    </div>
  );
}
